import { pascalToSnakeCase, snakeToTitleCase } from '@domain-group/javascript-utils'

import { ActivityModel } from '@domain-group/realhub-backend-api-types'

export const destructiveActions = [
  'archived',
  'deleted',
  'failed',
  'removed',
  'reverted',
  'unapproved',
]

export const renderActionText = (activity: ActivityModel) => {
  const { key, parameters = {} as ActivityModel['parameters'], recipient_type } = activity

  if (recipient_type === 'ProviderPriceList' && parameters?.deleted){
    const { entity_id, entity_type = '' } = parameters || {}
    const entityType = snakeToTitleCase(pascalToSnakeCase(entity_type))

    return `${entityType} # ${entity_id} Deleted`
  }

  if (key){
    const [subject, action] = key.split('.')
    return `${snakeToTitleCase(subject)} ${snakeToTitleCase(action)}`
  }

  return undefined
}
